import { reactive, ref, onMounted } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1f1b5ccf"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "revenue-header"
};
const _hoisted_2 = {
  class: "filter-content"
};
const _hoisted_3 = {
  class: "left"
};
const _hoisted_4 = {
  class: "time-content"
};
const _hoisted_5 = {
  class: "time-select-content"
};
const _hoisted_6 = {
  class: "filter-list"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "time-title"
}, "时间段", -1));
const _hoisted_8 = {
  class: "condition-content"
};
const _hoisted_9 = {
  class: "condition-select-content"
};
const _hoisted_10 = {
  class: "filter-list"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "产品名称", -1));
const _hoisted_12 = {
  class: "appListPopover-content"
};
const _hoisted_13 = {
  class: "appListPopover-content-title"
};
const _hoisted_14 = {
  class: "inf-label"
};
const _hoisted_15 = {
  class: "inf-value"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "复制", -1));
const _hoisted_17 = {
  class: "filter-list"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "包名", -1));
const _hoisted_19 = {
  class: "filter-list"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "国家", -1));
const _hoisted_21 = {
  class: "filter-list"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "版本", -1));
const _hoisted_23 = {
  class: "filter-list"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "内购ID", -1));
const _hoisted_25 = {
  class: "filter-list"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "AF-投放渠道", -1));
const _hoisted_27 = {
  class: "filter-list"
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "AF-投放计划", -1));
const _hoisted_29 = {
  class: "filter-list"
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "初始启动时间(绝对)", -1));
const _hoisted_31 = {
  class: "right"
};
import dayjs from 'dayjs';
import { queryEventFilters } from '@/api/pay';
import DbtDatePicker from '@/components/DbtDatePicker.vue';
import { awaitWrap, detailFields, OK, getNode, searchFields, getAppListInformation, copy } from '@/common';
import { message } from 'ant-design-vue';
import { ProductSelect } from '@dbt/product-select';
import '@dbt/product-select/dist/style.css';
import { queryGoodsOption } from '@/api/goodsSetting';
export default /*#__PURE__*/_defineComponent({
  __name: 'RevenueHeader',
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['returnSearch'],
  setup(__props, {
    emit
  }) {
    const periodList = [{
      label: '小时',
      value: 'T0'
    }, {
      label: '天',
      value: 'T1'
    }, {
      label: '周',
      value: 'T2'
    }, {
      label: '月',
      value: 'T3'
    }];
    const formState = reactive({
      startTime: dayjs(new Date().getTime() - 7 * 24 * 3600 * 1000).format('YYYYMMDD'),
      initTimeStart: '',
      initTimeEnd: '',
      endTime: dayjs(new Date().getTime() - 24 * 3600 * 1000).format('YYYYMMDD'),
      recentDay: '7-1',
      dynamic: 0,
      fromDayToDay: 0,
      useServerTime: false // true 开启服务器时间
    });
    const appList = ref([]);
    const channelList = ref([]);
    const regionList = ref([]);
    const verList = ref([]);
    const prodList = ref([]);
    const timeZoneType = ref('Asia/Shanghai');
    const datePeriod = ref('T1');
    const dbtIdList = ref([]);
    const appVersionList = ref([]);
    const payChnl = ref([]);
    const pkgIdList = ref([]);
    const regionIdList = ref([]);
    const pkgList = ref();
    const afCampaignList = ref();
    const afCampaignIdList = ref([]);
    const afSourceList = ref();
    const afSourceIdList = ref();
    const studioChecked = ref([]);
    const productSelectRef = ref(null);
    const pkgSelectRef = ref(null);
    const regionSelectRef = ref(null);
    const versionSelectRef = ref(null);
    const chanlSelectRef = ref(null);
    const afSelectRef = ref(null);
    const afCampaignRef = ref(null);
    const getAppData = async () => {
      const [err, data] = await awaitWrap(queryGoodsOption());
      if (data) {
        if (data.code === OK) {
          var _data$data, _productSelectRef$val;
          appList.value = data === null || data === void 0 || (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.map(item => {
            var _item$extData;
            return {
              ...item,
              checked: false,
              label: item.appName,
              value: item.dbtId,
              ...item.extData,
              filePath: ((_item$extData = item.extData) === null || _item$extData === void 0 ? void 0 : _item$extData.filePath) || '-'
            };
          });
          (_productSelectRef$val = productSelectRef.value) === null || _productSelectRef$val === void 0 || _productSelectRef$val.initializeOptions(appList.value);
        } else {
          message.error(data.msg);
        }
      }
      if (err) {}
    };
    const getChannel = async arr => {
      try {
        const {
          code,
          data: {
            options
          }
        } = await queryEventFilters({
          dbtIds: arr,
          eventCodes: []
        });
        if (code === '0') {
          var _options$_app_version, _options$sku, _options$_country, _options$_pkg, _options$afcampaign, _options$afsource, _options$prod_id, _pkgSelectRef$value, _regionSelectRef$valu, _versionSelectRef$val, _chanlSelectRef$value, _afSelectRef$value, _afCampaignRef$value;
          verList.value = options === null || options === void 0 || (_options$_app_version = options._app_version) === null || _options$_app_version === void 0 ? void 0 : _options$_app_version.map(item => {
            return {
              ...item,
              checked: false,
              label: item,
              value: item
            };
          });
          channelList.value = options === null || options === void 0 || (_options$sku = options.sku) === null || _options$sku === void 0 ? void 0 : _options$sku.map(item => {
            return {
              ...item,
              checked: false,
              label: item,
              value: item
            };
          });
          regionList.value = options === null || options === void 0 || (_options$_country = options._country) === null || _options$_country === void 0 ? void 0 : _options$_country.map(item => {
            return {
              ...item,
              checked: false,
              label: item,
              value: item
            };
          });
          pkgList.value = options === null || options === void 0 || (_options$_pkg = options._pkg) === null || _options$_pkg === void 0 ? void 0 : _options$_pkg.map(item => {
            return {
              ...item,
              checked: false,
              label: item,
              value: item
            };
          });
          afCampaignList.value = options === null || options === void 0 || (_options$afcampaign = options.afcampaign) === null || _options$afcampaign === void 0 ? void 0 : _options$afcampaign.map(item => {
            return {
              ...item,
              checked: false,
              label: item,
              value: item
            };
          });
          afSourceList.value = options === null || options === void 0 || (_options$afsource = options.afsource) === null || _options$afsource === void 0 ? void 0 : _options$afsource.map(item => {
            return {
              ...item,
              checked: false,
              label: item,
              value: item
            };
          });
          prodList.value = options === null || options === void 0 || (_options$prod_id = options.prod_id) === null || _options$prod_id === void 0 ? void 0 : _options$prod_id.map(item => {
            return {
              ...item,
              checked: false,
              label: item.dimensionName ? item.dimensionName + '(' + item.dimensionCode + ')' : item.dimensionCode,
              value: item.dimensionCode
            };
          });
          (_pkgSelectRef$value = pkgSelectRef.value) === null || _pkgSelectRef$value === void 0 || _pkgSelectRef$value.initializeOptions(pkgList.value);
          (_regionSelectRef$valu = regionSelectRef.value) === null || _regionSelectRef$valu === void 0 || _regionSelectRef$valu.initializeOptions(regionList.value);
          (_versionSelectRef$val = versionSelectRef.value) === null || _versionSelectRef$val === void 0 || _versionSelectRef$val.initializeOptions(verList.value);
          (_chanlSelectRef$value = chanlSelectRef.value) === null || _chanlSelectRef$value === void 0 || _chanlSelectRef$value.initializeOptions(channelList.value);
          (_afSelectRef$value = afSelectRef.value) === null || _afSelectRef$value === void 0 || _afSelectRef$value.initializeOptions(afSourceList.value);
          (_afCampaignRef$value = afCampaignRef.value) === null || _afCampaignRef$value === void 0 || _afCampaignRef$value.initializeOptions(afCampaignList.value);
        }
      } catch (e) {}
    };
    const returnChecked = () => {
      verList.value = [];
      channelList.value = [];
      regionList.value = [];
      pkgList.value = [];
      afCampaignList.value = [];
      afSourceList.value = [];
      prodList.value = [];
      if (!dbtIdList.value.length) return;
      getChannel(dbtIdList.value);
    };
    const returnChanl = arr => {
      payChnl.value = arr;
    };
    const returnRegion = arr => {
      regionIdList.value = arr;
    };
    const returnVersion = arr => {
      appVersionList.value = arr;
    };
    const returnPkg = arr => {
      pkgIdList.value = arr;
    };
    const returnAfCampaign = arr => {
      afCampaignIdList.value = arr;
    };
    const returnAfSource = arr => {
      afSourceIdList.value = arr;
    };
    const resetSearch = () => {
      timeZoneType.value = 'Asia/Shanghai';
      datePeriod.value = 'T1';
      dbtIdList.value = [];
      studioChecked.value = [];
      appVersionList.value = [];
      payChnl.value = [];
      regionIdList.value = [];
      pkgIdList.value = [];
      pkgList.value = [];
      afCampaignIdList.value = [];
      afSourceIdList.value = [];
      Object.assign(formState, {
        startTime: dayjs(new Date().getTime() - 7 * 24 * 3600 * 1000).format('YYYYMMDD'),
        endTime: dayjs(new Date().getTime() - 24 * 3600 * 1000).format('YYYYMMDD'),
        recentDay: '7-1',
        dynamic: 0,
        fromDayToDay: 0,
        useServerTime: false,
        initTimeStart: '',
        initTimeEnd: ''
      });
      getAppData();
      // search()
    };
    const handleTime = time => {
      const year = time.substring(0, 4);
      const month = time.substring(4, 6);
      const day = time.substring(6, 8);
      const date = new Date(year, month - 1, day);
      return date.getFullYear() + (date.getMonth() + 1).toString().padStart(2, '0') + date.getDate().toString().padStart(2, '0');
    };
    const search = () => {
      var _appList$value, _dbtIdList$value;
      const appName = (_appList$value = appList.value) === null || _appList$value === void 0 || (_appList$value = _appList$value.find(i => dbtIdList.value.includes(i.value))) === null || _appList$value === void 0 ? void 0 : _appList$value.label;
      const apps = (_dbtIdList$value = dbtIdList.value) === null || _dbtIdList$value === void 0 ? void 0 : _dbtIdList$value.map(item => {
        return {
          dbtId: item,
          appName: appName
        };
      });
      if (!apps.length) return message.error('请选择产品');
      const searchObj = {
        req: {
          dynamic: formState.dynamic,
          endTime: handleTime(formState.endTime),
          filtersView: {
            _app_version: appVersionList.value,
            _country: regionIdList.value,
            _init_open_time: formState.initTimeStart ? [handleTime(formState.initTimeStart), handleTime(formState.initTimeEnd)] : [],
            _pkg: pkgIdList.value,
            sku: payChnl.value,
            afcampaign: afCampaignIdList.value,
            afsource: afSourceIdList.value
          },
          startTime: handleTime(formState.startTime),
          timeShape: datePeriod.value,
          useServerTime: formState.useServerTime
        },
        apps
      };
      emit('returnSearch', searchObj);
    };
    onMounted(() => {
      getAppData();
    });
    return (_ctx, _cache) => {
      const _component_a_select = _resolveComponent("a-select");
      const _component_SvgIcon = _resolveComponent("SvgIcon");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_button = _resolveComponent("a-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createVNode(DbtDatePicker, {
        "select-date-range": [_unref(dayjs)().subtract(3, 'month'), _unref(dayjs)()],
        startTime: formState.startTime,
        "onUpdate:startTime": _cache[0] || (_cache[0] = $event => formState.startTime = $event),
        endTime: formState.endTime,
        "onUpdate:endTime": _cache[1] || (_cache[1] = $event => formState.endTime = $event),
        recentDay: formState.recentDay,
        "onUpdate:recentDay": _cache[2] || (_cache[2] = $event => formState.recentDay = $event),
        dynamic: formState.dynamic,
        "onUpdate:dynamic": _cache[3] || (_cache[3] = $event => formState.dynamic = $event),
        fromDayToDay: formState.fromDayToDay,
        "onUpdate:fromDayToDay": _cache[4] || (_cache[4] = $event => formState.fromDayToDay = $event),
        useServerTime: formState.useServerTime,
        "onUpdate:useServerTime": _cache[5] || (_cache[5] = $event => formState.useServerTime = $event),
        position: "bottomLeft"
      }, null, 8, ["select-date-range", "startTime", "endTime", "recentDay", "dynamic", "fromDayToDay", "useServerTime"]), _createVNode(_component_a_select, {
        class: "time-period",
        placeholder: "请选择时间周期",
        options: periodList,
        value: datePeriod.value,
        "onUpdate:value": _cache[6] || (_cache[6] = $event => datePeriod.value = $event),
        getPopupContainer: _unref(getNode)
      }, null, 8, ["value", "getPopupContainer"])])])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_hoisted_11, _createVNode(_unref(ProductSelect), {
        ref_key: "productSelectRef",
        ref: productSelectRef,
        modelValue: dbtIdList.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => dbtIdList.value = $event),
        multiple: true,
        "show-select-all": true,
        "show-extra": true,
        "search-fields": _unref(searchFields),
        "max-tag-count": 1,
        "max-select-count": 5,
        "show-detail": true,
        layout: "vertical",
        descriptionField: "filePath",
        width: "100%",
        customClassName: "revenue-product-label",
        "popup-class-name": "vertical-product-select",
        placeholder: "请选择",
        detailFields: _unref(detailFields),
        onChange: returnChecked,
        "show-bottom-border": ""
      }, {
        detail: _withCtx(({
          detail
        }) => [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createVNode(_component_SvgIcon, {
          iconClass: "informationIcon",
          class: "informationIcon"
        }), _createTextVNode(" " + _toDisplayString(detail.label), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAppListInformation)(detail.extData), child => {
          return _openBlock(), _createElementBlock("div", {
            key: child.label,
            class: "inf-line"
          }, [_createElementVNode("div", _hoisted_14, _toDisplayString(child.label) + "：", 1), _createElementVNode("div", _hoisted_15, _toDisplayString(child.value), 1), _createVNode(_component_a_tooltip, {
            placement: "top"
          }, {
            title: _withCtx(() => [_hoisted_16]),
            default: _withCtx(() => [_createVNode(_component_SvgIcon, {
              iconClass: "copy",
              class: "dbt-copyIcon",
              onClick: $event => _unref(copy)(child.value)
            }, null, 8, ["onClick"])]),
            _: 2
          }, 1024)]);
        }), 128))])]),
        _: 1
      }, 8, ["modelValue", "search-fields", "detailFields"])]), _createElementVNode("div", _hoisted_17, [_hoisted_18, _createVNode(_unref(ProductSelect), {
        ref_key: "pkgSelectRef",
        ref: pkgSelectRef,
        modelValue: pkgIdList.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => pkgIdList.value = $event),
        multiple: true,
        "show-select-all": true,
        "show-extra": false,
        "search-fields": _unref(searchFields),
        "max-tag-count": 1,
        "show-detail": false,
        layout: "horizontal",
        width: "100%",
        customClassName: "revenue-product-label",
        "popup-class-name": "revenue-product-select",
        placeholder: "请选择",
        onChange: returnPkg
      }, null, 8, ["modelValue", "search-fields"])]), _createElementVNode("div", _hoisted_19, [_hoisted_20, _createVNode(_unref(ProductSelect), {
        ref_key: "regionSelectRef",
        ref: regionSelectRef,
        modelValue: regionIdList.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => regionIdList.value = $event),
        multiple: true,
        "show-select-all": true,
        "show-extra": false,
        "search-fields": _unref(searchFields),
        "max-tag-count": 1,
        "show-detail": false,
        layout: "horizontal",
        width: "100%",
        customClassName: "revenue-product-label",
        "popup-class-name": "revenue-product-select",
        placeholder: "请选择",
        onChange: returnRegion
      }, null, 8, ["modelValue", "search-fields"])]), _createElementVNode("div", _hoisted_21, [_hoisted_22, _createVNode(_unref(ProductSelect), {
        ref_key: "versionSelectRef",
        ref: versionSelectRef,
        modelValue: appVersionList.value,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => appVersionList.value = $event),
        multiple: true,
        "show-select-all": true,
        "show-extra": false,
        "search-fields": _unref(searchFields),
        "max-tag-count": 1,
        "show-detail": false,
        layout: "horizontal",
        width: "100%",
        customClassName: "revenue-product-label",
        "popup-class-name": "revenue-product-select",
        placeholder: "请选择",
        onChange: returnVersion
      }, null, 8, ["modelValue", "search-fields"])]), _createElementVNode("div", _hoisted_23, [_hoisted_24, _createVNode(_unref(ProductSelect), {
        ref_key: "chanlSelectRef",
        ref: chanlSelectRef,
        modelValue: payChnl.value,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => payChnl.value = $event),
        multiple: true,
        "show-select-all": true,
        "show-extra": false,
        "search-fields": _unref(searchFields),
        "max-tag-count": 1,
        "show-detail": false,
        layout: "horizontal",
        width: "100%",
        customClassName: "revenue-product-label",
        "popup-class-name": "revenue-product-select",
        placeholder: "请选择",
        onChange: returnChanl
      }, null, 8, ["modelValue", "search-fields"])]), _createElementVNode("div", _hoisted_25, [_hoisted_26, _createVNode(_unref(ProductSelect), {
        ref_key: "afSelectRef",
        ref: afSelectRef,
        modelValue: afSourceIdList.value,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => afSourceIdList.value = $event),
        multiple: true,
        "show-select-all": true,
        "show-extra": false,
        "search-fields": _unref(searchFields),
        "max-tag-count": 1,
        "show-detail": false,
        layout: "horizontal",
        width: "100%",
        customClassName: "revenue-product-label",
        "popup-class-name": "revenue-product-select",
        placeholder: "请选择",
        onChange: returnAfSource
      }, null, 8, ["modelValue", "search-fields"])]), _createElementVNode("div", _hoisted_27, [_hoisted_28, _createVNode(_unref(ProductSelect), {
        ref_key: "afCampaignRef",
        ref: afCampaignRef,
        modelValue: afCampaignIdList.value,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => afCampaignIdList.value = $event),
        multiple: true,
        "show-select-all": true,
        "show-extra": false,
        "search-fields": _unref(searchFields),
        "max-tag-count": 1,
        "show-detail": false,
        layout: "horizontal",
        width: "100%",
        customClassName: "revenue-product-label",
        "popup-class-name": "revenue-product-select",
        placeholder: "请选择",
        onChange: returnAfCampaign
      }, null, 8, ["modelValue", "search-fields"])]), _createElementVNode("div", _hoisted_29, [_hoisted_30, _createVNode(DbtDatePicker, {
        "show-dynamic": false,
        "show-use-server-time": false,
        "show-header": false,
        startTime: formState.initTimeStart,
        "onUpdate:startTime": _cache[14] || (_cache[14] = $event => formState.initTimeStart = $event),
        endTime: formState.initTimeEnd,
        "onUpdate:endTime": _cache[15] || (_cache[15] = $event => formState.initTimeEnd = $event),
        recentDay: formState.recentDay,
        "onUpdate:recentDay": _cache[16] || (_cache[16] = $event => formState.recentDay = $event),
        "is-required": false,
        position: "bottomLeft",
        isdeletion: ""
      }, null, 8, ["startTime", "endTime", "recentDay"])])])])]), _createElementVNode("div", _hoisted_31, [_createVNode(_component_a_button, {
        onClick: resetSearch
      }, {
        default: _withCtx(() => [_createTextVNode("重置")]),
        _: 1
      }), _createVNode(_component_a_button, {
        type: "primary",
        onClick: search,
        loading: __props.loading
      }, {
        default: _withCtx(() => [_createTextVNode("搜索")]),
        _: 1
      }, 8, ["loading"])])])]);
    };
  }
});